import { Record } from 'immutable';

import Hydrator from 'utils/Hydrator';

const ActivityGroupRecord = Record({
  id: 0,
  client: {
    companyName: '',
    companyNumber: '',
  },
  activities: [],
});

export default class ActivityGroup extends ActivityGroupRecord {
  static deserialize(jsonObject = {}) {
    if (!jsonObject) {
      return undefined;
    }

    const mapProperties = {};

    const hydrated = Object.keys(jsonObject).reduce(Hydrator.assign(jsonObject, mapProperties), {});

    return new ActivityGroup(hydrated);
  }

  get requiringAttentionActivitiesCount() {
    return this.activities.reduce((acc, activity) => +acc + +!!activity.isRequiringAttention(), 0);
  }

  get companyName() {
    return this.client ? this.client.companyName : '';
  }

  get fundingSearchId() {
    return this.activities.size ? this.activities.first().fundingSearchId : null;
  }

  sortedActivities() {
    return this.activities.sort((a, b) => a.status - b.status);
  }
}
